export const classificationActions = Object.freeze({
    EDIT_CLASSIFICATION: "EDIT_CLASSIFICATION",
    DELETE_CLASSIFICATION: "DELETE_CLASSIFICATION",
});
